/* global elementorFrontend */
import $ from 'jquery';

const footerMenu = () => {
	const $wrapper = $('.mi-footer-menu-wrapper');
	if (!$wrapper.length) return;

	$(document).off('click.miFooterMenu', '.mi-footer-menu-toggle').on('click.miFooterMenu', '.mi-footer-menu-toggle', function (e) {
		e.preventDefault();
		e.stopPropagation();

		const $btn = $(this);
		const $group = $btn.closest('.mi-footer-menu-group');
		if (!$group.length) return;

		const $sub = $group.find('.mi-footer-menu-sub');

		if ($group.hasClass('is-active')) {
			$group.removeClass('is-active');
			$sub.slideUp(300);
		} else {
			$group.addClass('is-active');
			$sub.slideDown(300);
		}
	});
};

try {
	footerMenu();

	$(window).on('elementor/frontend/init', () => {
		if (window.elementorFrontend && window.elementorFrontend.hooks) {
			window.elementorFrontend.hooks.addAction('frontend/element_ready/footer-menu.default', () => {
				footerMenu();
			});
		}
	});
} catch (error) {
	console.warn('Error in footerMenu:', error);
}

export default footerMenu;
